import { isMobileOnly, isMobile } from "react-device-detect";
import styled from "styled-components";

const limitprop = (props) => {
  if (props.selfexcludion) {
    return "flex-table-row justify-content-center py-5";
  } else {
    return `flex-table-row justify-content-center flex-wrap ${
      (props.theme.skin === "pub" ||
        props.theme.skin === "cac" ||
        props.theme.skin === "hyc") &&
      isMobile
        ? "pb-3"
        : props.theme.skin === "rac"
          ? "py-5 border-left border-right border-bottom border-top"
          : "py-5"
    }`;
  }
};

export const StyledLimitWrapper = styled.div.attrs((props) => ({
  className: limitprop(props),
}))`
  align-items: ${({ theme, timelimitAbc, bonuscode }) =>
    timelimitAbc
      ? "baseline"
      : theme.skin === "rac"
        ? bonuscode
          ? "end"
          : "center"
        : "flex-end"};

  .form-control:disabled {
    background-color: #45454573 !important;
  }
  text-align: ${({ verification }) => verification && "left"};
  max-width: ${(reviewTransactions) => (reviewTransactions ? "1024px" : "")};
  margin: ${(reviewTransactions) => (reviewTransactions ? "auto" : "")};
  padding-bottom: ${(reviewTransactions) =>
    reviewTransactions ? "0 !important" : ""};
  button {
    margin: ${(reviewTransactions) =>
      reviewTransactions && isMobileOnly ? "2rem 1rem" : ""};
  }
`;

export const StyledLimitSelect = styled.div.attrs((props) => ({
  className: "form-group col-md-3",
}))``;

export const RealityCheckWrapper = styled.div.attrs((props) => ({
  className: `flex-table-row justify-content-${
    props.theme.skin === "rac" ? "center pt-3" : "left"
  } `,
}))`
  p {
    color: var(--smallHeaderABC);
  }
  padding-top: ${({ extrapadding }) => (extrapadding ? "1rem" : "")};
  text-align: ${({ extrapadding }) => (extrapadding ? "center" : "")};
`;

export const IncreaseLimit = styled.div.attrs({
  className: "flex-table-row justify-content-center p-3 border-0",
})``;

export const StyledTimeLimit = styled.div.attrs((props) => ({
  className: `form-group col-md-4 ${
    (props.theme.skin === "abc" ||
      props.theme.skin === "nbc" ||
      props.theme.skin === "yet" ||
      props.theme.skin === "fun" ||
      props.theme.skin === "rac" ||
      props.theme.skin === "qbc" ||
      props.theme.skin === "bec") &&
    !isMobileOnly
      ? "pb-5"
      : ""
  }`,
}))`
  .invalid-feedback {
    text-align: left;
  }
  label {
    margin-bottom: 0;
    line-height: 0;
  }
  .ver-check {
    .custom-input {
      border-radius: 0.5rem 0 0 0.5rem !important;
    }
    .invalid-feedback {
      margin-top: 55px;
    }
  }
`;

export const StyledSectionTimeLimit = styled.div.attrs((props) => ({
  className: `flex-table-row ${props.padding} justify-content-center ${props.border}`,
}))``;

export const MessageLock = styled.div.attrs({
  className: `flex-table-row text-center p-3`,
})``;

export const StyledIndefiniteTimeout = styled.div.attrs({
  className:
    "flex-table-row justify-content-center p-3 border border-top-0 rounded-bottom",
})``;

export const ExcludedGamesWrapper = styled.div.attrs((props) => ({
  className:
    props.theme.skin === "abc"
      ? "m-auto w-100 pt-5"
      : "border-bottom m-auto w-100",
}))``;

export const SectionExcludedGameWeapper = styled.div.attrs((props) => ({
  className: `flex-table-row justify-content-center ${props.excludedlimits}`,
}))`
  ${(props) => {
    if (props.spanStyle) {
      return `
      .btn {
        font-size: inherit;
      }

      @media (max-width: 767px) {
        .form-check-inline {
          font-size: 0.7rem;
        }
      }
      `;
    }
    if (props.realitycheck) {
      return `
      border-left: 1px solid var(--bordercolor) !important;
      border-right: 1px solid var(--bordercolor)!important;
      `;
    }
  }}
`;

export const StyledBlockedGames = styled.div.attrs({
  className:
    "flex-table-row flex-table-row-header justify-content-center border-top border-bottom",
})``;

export const BlockedGamesTableCell = styled.div.attrs({
  className: "flex-table-cell title-content col-md-4",
})``;

export const StyledCooldownExplanation = styled.div`
  width: 610px;
  ${(props) => {
    if (props.cooldownprop) {
      return `
      
      @media (max-width: 767px) {
        position: relative;
        top: ${props.theme.skin === "qbc" ? "-82px" : "-100px"};
        left: 15px;
      }
        
      `;
    }
  }}
`;
export const StyledCooldownExplanationSmall = styled.small.attrs({
  className: "form-text text-muted",
})``;

export const RemainingAmountWrapper = styled.div`
  color: red;
`;
